import React, {useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import axios from 'axios'

import {setInitData} from '../../actions/initAction'
import {isPin,togglePin} from '../../helpers'

const setStart = ({setApp,defaultLayers,layers,tool,map,aoiLayerResult}) => {
  if(aoiLayerResult){
    map.removeLayer(aoiLayerResult)
  }
  setApp(setInitData({defaultLayers,layers,tool}))
  if(!isPin()){
    togglePin(map)
  }
}

const TSmills = () => {
  const {map} = useSelector(s=>s.map)
  const toolScreen = useSelector(s=>s.toolScreen)
  const setApp = useDispatch()
  const { layers, defaultLayers } = useSelector(s=>s.layers);
  const {rLang, lang} = useSelector(s=>s.lang)
  const {aoiLayerResult} = useSelector(s=>s.aoi)

  useEffect(()=>{
    if(map && typeof document !== undefined){
      /*Mills*/
      axios.get('https://nusantara-atlas.org/dbrest/' + layers.mill.sLayer + '?select=count')
      .then(function(r){
        document.querySelector('#sum-mill .sum-t > div').innerText = r.data[0].count;
      });
      axios.get('https://nusantara-atlas.org/dbrest/' + layers.mill.gUrl + '?select=count')
      .then(function(r){
        document.querySelector('#sum-mill .sum-g > div').innerText = r.data[0].count;
      });
    }



  },/*eslint-disable-line react-hooks/exhaustive-deps*/[map])

  return (
    <>
      <div id="tool-info-mill" className="tool-info" style={toolScreen.tool !== 'mill' ? css.hide : css.show}>
        <div className="tool-bg"/>
        <div className="position-relative">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-9">
                <div className="tool-info-title">
                  {rLang.ToolMillTitle[lang]}
                </div>

                <div id="sum-mill" className="sum-d">
                  <div className="sum-t">
                    <div></div>
                    <span>{rLang.Mills[lang]}</span>
                  </div>
                  <div className="sum-g">
                    <div></div>
                    <span>{rLang.TWgroup[lang]}</span>
                  </div>
                </div>

                <div className="tool-info-desc">
                  {rLang.ToolMillDesc[lang]}
                </div>
                <button onClick={()=>{
                  setStart({setApp,tool:'mill',layers,defaultLayers,map,aoiLayerResult})
                }} className="start">{rLang.StartTool[lang]}</button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const css = {
  show: {
    opacity:1,
    zIndex:1,
    height:'auto',
    overflow:'auto'
  },
  hide: {
    opacity:0,
    zIndex:-1,
    height:0,
    overflow:'hidden'
  }
}

export default TSmills
